import $ from 'jquery'
import {
    handleTryPremiumContentClick,
    setAfterCheckoutRedirection,
} from './module_common';

import { 
    openSignInModal,
    signInGoToCheckoutAndBack, 
} from './module_auth_helper';

const actions = [
    "0",    // NOT IMPLEMENTED sign in "handleLoginClick(); return true;"
    "1",    // NOT IMPLEMENTED sign in and subscribe "openModalAndGotoUrl('mainModal','/it/abbonati')""
    "2",    // sign in and come back
    "3",    // sign in, subscribe
    "4",    // show TryPremium modal, subscribe, come back
    "5",    // only set current page as "afterCheckoutRedirect", used after onboarding, (and after checkout without onboarding?)
]

const visitorActionSelector = ".cta-action-attach-clk"

export function attachCtaActions(){
    $(visitorActionSelector).each(function(){
        $(this).click(function(e){
            const currTarget = $(e.currentTarget)

            switch (currTarget.data("actiontype")) {
                case 2:
                    e.preventDefault()
                    openSignInModal()
                    break;
                case 3:
                    e.preventDefault()
                    signInGoToCheckoutAndBack()
                    break;
                case 4:
                    e.preventDefault()
                    handleTryPremiumContentClick(window.location.href)
                    break;
                case 5:
                    setAfterCheckoutRedirection(window.location.href)
                    break;
                default:
                    break;
            }
        })
    })
}